"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readFile = exports.createFileFromUrl = exports.convertBytesToMbsOrKbs = exports.isImage = void 0;

var tslib_1 = require("tslib");

function isImage(file) {
  if (file.type.split("/")[0] === "image") {
    return true;
  }
}

exports.isImage = isImage;
var bytesInKiloB = 1024; // 2 ** 10;

var bytesInMegaB = 1048576; // bytesInKiloB ** 2;

function convertBytesToMbsOrKbs(filesize) {
  var size = "";

  if (filesize >= bytesInMegaB) {
    size = filesize / bytesInMegaB + " megabytes";
  } else if (filesize >= bytesInKiloB) {
    size = filesize / bytesInKiloB + " kilobytes";
  } else {
    size = filesize + " bytes";
  }

  return size;
}

exports.convertBytesToMbsOrKbs = convertBytesToMbsOrKbs;

function createFileFromUrl(url) {
  return (0, tslib_1.__awaiter)(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response, data, metadata, filename;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(url);

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response === null || response === void 0 ? void 0 : response.blob();

          case 5:
            data = _context.sent;
            metadata = {
              type: data.type
            };
            filename = url.replace(/\?.+/, "").split("/").pop();
            return _context.abrupt("return", new File([data], filename, metadata));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.createFileFromUrl = createFileFromUrl;

function readFile(file) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();

    reader.onload = function (event) {
      var _a;

      resolve((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.result);
    };

    reader.onerror = function (event) {
      reader.abort();
      reject(event);
    };

    reader.readAsDataURL(file);
  });
}

exports.readFile = readFile;